import { UserService } from "./../../services/user/user.service";
import { IHeaderSelector } from "./typing/header.interface";
import { RootState } from "../../store/rootStore";
import { createSelector } from "reselect";

const selectRawData = (state: RootState) => ({
  user: state.user,
  auth: state.authorization.auth,
  isVerifyed: state.authorization.isVerifyed,
  bonuses: state.bonuses.activatedBonuses,
});

export const HeaderSelector = createSelector(
  selectRawData,
  ({ user, auth, isVerifyed, bonuses }) => {
    const currentUser = new UserService(user);

    const summaryBalance = currentUser.getUserSummaryBalance();
    const wallet = user.wallets.filter((wallet) => wallet.active)[0];
    const active_bonus =
      bonuses.filter((bonus) => {
        if (bonus.bonus_user_fs_type) {
          return (
            bonus.bonus_user_fs_type.status === "active" ||
            bonus.bonus_user_fs_type.status === "deposit" ||
            bonus.bonus_user_fs_type.status === "use" ||
            bonus.bonus_user_fs_type.status === "wagering"
          );
        }
        if (bonus.bonus_user_pers_type) {
          return (
            bonus.bonus_user_pers_type.status === "active" ||
            bonus.bonus_user_pers_type.status === "deposit" ||
            bonus.bonus_user_pers_type.status === "use" ||
            bonus.bonus_user_pers_type.status === "wagering"
          );
        }
      }).length > 0;
    return {
      userBalance: summaryBalance,
      wallet,
      auth,
      active_bonus,
    } as IHeaderSelector;
  }
);
